import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { APIUtils } from '../../../../utils/apiutils';
import httpClient from '../../../../services/http';
import { REQUEST_CUSTOM_EVENTS } from '../requestConstants';

const useFetchRequestDetails = (requestId = '') => {
    const [requestDetails, setRequestDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        const controller = new AbortController();
        const updateRequestDetails = (e) => {
            const reqData = e?.detail;
            if (!reqData) { return; }
            setRequestDetails(prev => ({ ...prev, ...reqData }));
        };

        document.addEventListener(REQUEST_CUSTOM_EVENTS.UPDATE_REQ_DETAILS, updateRequestDetails, { signal: controller.signal });
        return () => {
            controller.abort();
        };
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const getRequestDetails = async (id) => {
            try {
                setLoading(true);
                const url = `${APIUtils.getAPIEndpoint('request-details')}/${id}`;
                const res = await httpClient.get(url, { signal: controller.signal }).then(res => res.data);
                if (res.status === 'success') {
                  setRequestDetails(res.data);
                }
            } catch (error) {
                console.error('Error fetching request details:', error);
                setError(error);
                if (error?.cause?.response?.data?.message) {
                    Swal.fire('Sorry!', error.cause.response.data.message, 'error');
                    return;
                }
                Swal.fire('Something Went Wrong!', '', 'error');
            } finally {
                setLoading(false);
            }
        };
        if (!requestId) {
          return;
        }
        getRequestDetails(requestId);

        document.addEventListener(REQUEST_CUSTOM_EVENTS.REFETCH_REQ_DETAILS, () => {getRequestDetails(requestId);}, { signal: controller.signal });

        return () => {
            controller.abort();
        };
    }, [requestId]);

    return { requestDetails, loading, error, setError };
};

export default useFetchRequestDetails;